export const BaseMapActionType = {
  SET_BASE_MAP: "SET_BASE_MAP",
  UPDATE_BASE_MAP: "UPDATE_BASE_MAP"
}